import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Home365LinkDirective } from './home365-link.directive';



@NgModule({
  declarations: [
    Home365LinkDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    Home365LinkDirective
  ]
})
export class Home365LinkModule { }
